import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/trendelantero/Precap2.png")